export const origins = (state) => {
  return state.origins.data || []
}

export const originsLoading = (state) => {
  return state.origins.loading
}

export const originsLastUpdate = (state) => {
  return state.origins.lastUpdate
}